export type AiApiProtocol = "chat_completions" | "responses";

export const AI_API_PROTOCOLS: AiApiProtocol[] = ["chat_completions", "responses"];

export const AI_API_PROTOCOL_LABELS: Record<AiApiProtocol, string> = {
  chat_completions: "Chat Completions",
  responses: "Responses",
};

export const DEFAULT_AI_API_PROTOCOL: AiApiProtocol = "chat_completions";

export function normalizeAiApiProtocol(value: unknown): AiApiProtocol {
  return value === "responses" ? "responses" : "chat_completions";
}

export interface AiProviderItem {
  providerId: string;
  name: string;
  baseUrl: string;
  apiKeyMasked: string;
  proxyUrlMasked: string;
  enabled: boolean;
  modelCount: number;
}

export interface AiProviderDetail
  extends Omit<AiProviderItem, "apiKeyMasked" | "proxyUrlMasked" | "modelCount"> {
  apiKey: string;
  proxyUrl: string;
}

export interface RemoteAiModelItem {
  id: string;
  ownedBy: string;
  alreadyImported: boolean;
}

export interface AiModelItem {
  modelId: string;
  providerId: string;
  providerName: string;
  remoteId: string;
  displayName: string;
  protocol: AiApiProtocol;
  enabled: boolean;
  isGlobalActive: boolean;
  isImageUnderstandingActive: boolean;
}

export interface ChatMessage {
  role: "system" | "user" | "assistant";
  content: string;
}
